import React, { Suspense } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import LandingNavbar from '../landing/LandingNavbar';
import RouteLoading from '../landing/RouteLoading';
import {
  FramedPageShell,
  LandingViewportFrame,
  authPageBackground,
} from '../landing/LandingViewportChrome';

const AuthContentArea = styled.main`
  position: relative;
  z-index: 20;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const AuthRouteFallback = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 8rem);
  background: ${authPageBackground};
`;

const AuthLayout = () => {
  return (
    <FramedPageShell $light>
      <LandingNavbar />
      <AuthContentArea>
        <Suspense
          fallback={(
            <AuthRouteFallback>
              <RouteLoading />
            </AuthRouteFallback>
          )}
        >
          <Outlet />
        </Suspense>
      </AuthContentArea>
      <LandingViewportFrame aria-hidden="true" />
    </FramedPageShell>
  );
};

export default AuthLayout;
